import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
// import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { TranslateModule } from '@ngx-translate/core';

import { AzavistaInputFieldModule } from '@azavista/components/input-field';
import { AzavistaButtonModule } from '@azavista/components/button';
import { ReadStatePipe } from './pipes/read-state.pipe';

@NgModule({
    declarations: [
        ReadStatePipe
    ],
    imports: [
        CommonModule, TranslateModule, FormsModule,
        MatDialogModule, MatFormFieldModule, MatInputModule,
        AzavistaInputFieldModule, AzavistaButtonModule,
        // MatBottomSheetModule,
    ],
    exports: [
        TranslateModule, FormsModule, MatFormFieldModule, MatInputModule, AzavistaInputFieldModule, AzavistaButtonModule,
        //  MatBottomSheetModule,

        // Pipes
        ReadStatePipe
    ]
})
export class SharedModule { }
